
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component({ name: 'warn' })
export default class IndexView extends Vue {
  @Prop({ type: String, default: '' }) text!: string
}
